import { Fade } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

import styled from 'styled-components';

import { fontFamily } from '../../libs';

export const AlertStyled = styled(Alert)`
  margin: ${(props) => props.margin || '4px 7px'};
  box-shadow: 0 1px 2px #00000040 !important;

  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'auto')};

  .MuiAlert-message {
    word-break: break-word !important;
  }

  .MuiTypography-root {
    margin: 0 !important;
  }

  * {
    font-family: ${fontFamily} !important;
    font-weight: bold !important;
  }

  svg {
    margin: auto;
  }
`;

export const Message = styled.p`
  margin: 6px 0;
`;

export const FadeStyled = styled(Fade)``;

export default AlertStyled;
